<div
  class="choose-lang__lang"
  [class.login_modal]="loginModal"
  [class.choose-lang__lang--header]="mode === 'header'"
  [class.choose-lang__lang--mobile]="mode === 'mobile'"
>
  <div class="choose-lang__lang-active" (click)="toggleList()">
    <span class="choose-lang__lang-text">{{ activeLang?.title }}</span>
  </div>
  <div class="choose-lang__lang-list" [ngClass]="{ 'choose-lang__lang-list--opened': isListOpened }">
    @for (lang of langList; track lang) {
      <div
        class="choose-lang__lang-position"
        (click)="setActiveLanguage(lang)"
        [class.active]="activeLang?.code === lang.code"
      >
        <span class="choose-lang__lang-text">{{ lang.title }}</span>
      </div>
    }
  </div>
</div>
